"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DomainEvent_1 = require("../Engine/Event/DomainEvent");
const ChatDefinition_1 = require("./ChatDefinition");
class ChatEvent {
    /**
     *
     *
     * @static
     * @param {string} chatId
     * @param {ChatMessageDto[]} cms Client received earlier ChatMessageDto[]
     * @returns {DomainEvent}
     * @memberof ChatEvent
     */
    static EalierChatMessagesArrivedEvent(chatId, cms) {
        return new DomainEvent_1.DomainEvent({
            version: ChatEvent.Version,
            category: ChatEvent.Category,
            name: ChatEvent.EalierChatMessagesArrived,
            entityId: chatId,
            body: cms
        });
    }
    /**
     * This event occured when a participant spoke a ChatMessage
     *
     * @static
     * @param {string} chatId
     * @param {Tuple4<string, string, ChatMessageDto[], number>} chatIdCmDtos
     * ```ts
     * {
     *   chatIdCmDtos.Item1: string, //Chat.id
     *   chatIdCmDtos.Item2: string, //Chat.TempId.
     *   chatIdCmDtos.Item3: ChatMessageDto[], //participant spoke chat messages.
     *   chatIdCmDtos.Item4: number, //Chat.TotalChatMessageCount during this event occurred.
     * }
     * ```
     *
     * @returns {DomainEvent}
     * @memberof ChatEvent
     */
    static ParticipantSpokeEvent(chatId, chatIdCmDtos) {
        return new DomainEvent_1.DomainEvent({
            version: ChatEvent.Version,
            category: ChatEvent.Category,
            name: ChatEvent.ParticipantSpoke,
            entityId: chatId,
            body: chatIdCmDtos
        });
    }
    /**
     * This event occured when a participant reported read count to service.
     *
     * @static
     * @param {string} chatId
     * @param {Tuple3<string, string, number>} chatIdParticipantReadCount The body is a 3 element Tuple.
     * ```ts
     * {
     *   Item1: string, //Chat.id
     *   Item2: string, //The Chat's participant name
     *   Item3: number, //The read count of participant.
     * }
     * ```
     *
     * @returns {DomainEvent}
     * @memberof ChatEvent
     */
    static ParticipantReadToMessageCountEvent(chatId, chatIdParticipantReadCount) {
        return new DomainEvent_1.DomainEvent({
            version: ChatEvent.Version,
            category: ChatEvent.Category,
            name: ChatEvent.ParticipantReadToMessageCount,
            entityId: chatId,
            body: chatIdParticipantReadCount
        });
    }
    static NewChatIsCreatedEvent(chatDto) {
        return new DomainEvent_1.DomainEvent({
            version: ChatEvent.Version,
            category: ChatEvent.Category,
            name: ChatEvent.NewChatIsCreated,
            entityId: "",
            body: chatDto
        });
    }
}
ChatEvent.Version = ChatDefinition_1.ChatVersion;
ChatEvent.Category = ChatDefinition_1.ChatEventCategory;
ChatEvent.ParticipantSpoke = "ParticipantSpoke";
ChatEvent.ParticipantReadToMessageCount = "ParticipantReadToMessageCount";
ChatEvent.EalierChatMessagesArrived = "EalierChatMessagesArrived";
ChatEvent.NewChatIsCreated = "NewChatIsCreated";
exports.ChatEvent = ChatEvent;
//# sourceMappingURL=ChatEvent.js.map